import { Tracker } from '@gymondo/frontend-core/utils'

const EVENT_VALUES = {
    'main-cta': 1,
    'image-cta': 2,
}

export const generateTrackingAttributes = ({ label, value }) => ({
    'data-evt': Tracker.EVENT_TYPES.CLICK,
    'data-category': 'community',
    'data-action': 'community_use_cta',
    'data-label': label,
    'data-value': EVENT_VALUES[value],
})
